import React, { ReactNode, useState } from 'react';
import Sticky from 'react-stickynode';

import { CtaButtonGroup } from '..';
import { APPEARANCE, HERO_SECTION, PROFILE_TIERS } from '../../constants';

import * as styles from './sticky-bar.style';

export type Props = {
  profileTier: PROFILE_TIERS;
  isAgency: boolean;
  name: string;
  agencyColour?: string;
  phoneNumber: string;
  hasEmail?: boolean | null;
  setStickyActive: (value: boolean) => void;
  emailFormComponentId: string;
  onCallButtonClick?: () => void;
  onEmailButtonClick?: () => void;
  children: ReactNode;
  desktopWidth?: number;
  showRatings?: boolean;
};

// TODO: after @types/react-stickynode is updated, we can re-add that as a dev dependency and replace this interim enum with the correct type - Sticky.StatusCode
// def ref: https://github.com/yahoo/react-stickynode/blob/a7a7ae8d2f475af326311a64c6c87bbbe6161854/src/Sticky.jsx#L16
enum StickyStatus {
  STATUS_ORIGINAL = 0, // The default status, locating at the original position.
  STATUS_RELEASED = 1, // The released status, locating at somewhere on document but not default one.
  STATUS_FIXED = 2, // The sticky status, locating fixed to the top or the bottom of screen.
}

const StickyBar = ({
  isAgency,
  name,
  profileTier,
  agencyColour,
  phoneNumber,
  hasEmail,
  setStickyActive,
  emailFormComponentId,
  onCallButtonClick = () => undefined,
  onEmailButtonClick = () => undefined,
  children,
  desktopWidth = 992,
  showRatings = false,
}: Props): JSX.Element => {
  const [isStickyActive, setIsStickyActive] = useState(false);

  const onStateChange = ({ status }: { status: StickyStatus }) => {
    switch (status) {
      case StickyStatus.STATUS_FIXED: {
        setStickyActive(true);
        setIsStickyActive(true);
        break;
      }
      default: {
        setStickyActive(false);
        setIsStickyActive(false);
      }
    }
  };

  return (
    <div css={styles.stickyOuterWrapper({ isAgency, profileTier })}>
      <Sticky top="trade-profile-hero__banner" onStateChange={onStateChange}>
        <div css={styles.stickyWrapper}>
          <div
            css={styles.stickyBar({
              desktopWidth,
              showRatings,
              isStickyActive,
            })}
            data-testid="sticky-bar"
            style={{
              borderBottomColor: agencyColour || 'transparent',
            }}
          >
            <div
              css={styles.stickyDetails}
              data-testid="trade-profile-hero__sticky-details"
            >
              {children}
            </div>
            <CtaButtonGroup
              isAgency={isAgency}
              profileTier={profileTier}
              callButtonAppearance={APPEARANCE.ghost}
              emailButtonAppearance={APPEARANCE.highlight}
              heroSection={HERO_SECTION.sticky}
              phoneNumber={phoneNumber}
              name={name}
              onCallButtonClick={onCallButtonClick}
              hasEmail={hasEmail}
              emailFormComponentId={emailFormComponentId}
              onEmailButtonClick={onEmailButtonClick}
            />
          </div>
        </div>
      </Sticky>
    </div>
  );
};

export default StickyBar;
